
import Logo from '../../src/asset/images/logo.svg'
const AccountDeletion = () => {

    return (
        <>
            <header className="sticky-top">
                <nav className="navbar navbar-expand-lg py-2">
                    <div className="container">
                        <a className="navbar-brand" href="/"><img src={Logo} alt="img" /></a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                </nav>
            </header>
            <section class="py-4">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex align-items-center justify-content-center">
                                <h1 class="fw-bold text-decoration-underline text-center">
                                    Delete Your Account – Shadowz
                                </h1>
                                <p></p>
                            </div>

                            <div class="mx-auto p-4" style={{ maxWidth: '900px', fontFamily: 'sans-serif' }}>

                                <p class="mt-4 text-muted">
                                    At <strong>Shadowz</strong>, we value your privacy and
                                    provide a simple way to delete your account and personal data.
                                    If you no longer wish to use our services, follow the
                                    instructions below.
                                </p>

                                <h2 class="mt-4 fw-semibold text-dark">
                                    How to Delete Your Account
                                </h2>

                                <h3 class="mt-3 fw-semibold text-dark">
                                    Option 1: Delete from the App
                                </h3>

                                <ol class="mt-2 text-muted">
                                    <li>Open the <strong>Shadowz</strong> app.</li>
                                    <li>
                                        Go to <strong>Profile → View Profile → Account Information</strong> and click on the menu.
                                    </li>
                                    <li>
                                        Tap on <strong>Delete My Account</strong> and follow the on-screen instructions.
                                    </li>
                                    <li>Your account and all associated data will be permanently deleted.</li>
                                </ol>

                                <h3 class="mt-4 fw-semibold text-dark">
                                    Option 2: Request Deletion via Email
                                </h3>

                                <p class="mt-2 text-muted">
                                    If you are unable to delete your account from the app, you can request deletion via email.
                                </p>

                                <p class="mt-2 fw-semibold text-primary">
                                    Email us at:
                                    <a href="mailto:info@Shadowz.com" class="text-decoration-underline">
                                        info@shadowz.com
                                    </a>
                                </p>

                                <p class="mt-2"><strong>Subject:</strong> Account Deletion Request</p>

                                <p class="mt-1"><strong>Include:</strong></p>
                                <ul class="text-muted">
                                    <li>Your registered phone number or email</li>
                                    <li>Reason for deletion (optional)</li>
                                </ul>

                                <h2 class="mt-4 fw-semibold text-dark">What Happens After Deletion?</h2>

                                <ul class="mt-2 text-muted">
                                    <li>All personal data, including ride history and payment details, will be permanently removed.</li>
                                    <li>Any active ride requests or bookings will be canceled automatically.</li>
                                    <li>Deletion requests are processed within <strong>7 business days</strong>.</li>
                                </ul>

                                <p class="mt-3 fw-semibold text-danger">
                                    Note: If you have any pending payments or refunds, they must be resolved before deletion.
                                </p>

                                <h2 class="mt-4 fw-semibold text-dark">Need Help?</h2>

                                <p class="mt-2 text-muted">
                                    For assistance, contact us at
                                    <a href="mailto:info@Shadowz.com" class="text-primary text-decoration-underline">
                                        info@shadowz.com
                                    </a>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default AccountDeletion


















